import { render } from "./px-panel-section.vue?vue&type=template&id=591b1418&scoped=true&ts=true"
import script from "./px-panel-section.vue?vue&type=script&lang=ts"
export * from "./px-panel-section.vue?vue&type=script&lang=ts"

import "./px-panel-section.vue?vue&type=style&index=0&id=591b1418&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591b1418"]])

export default __exports__